import * as authAPI from "app/api/authenticationAPI";
import * as countriesApi from "app/api/countriesApi";
import { TextInput } from "app/components/FormInputs/FormInputs";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import Recaptcha from "../Recaptcha/Recaptcha";
import "./AuthScreenForgottenEmailModal.scss";

const LoadingSpinner: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/LoadingSpinner/LoadingSpinner")
);
const Modal: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/Modal/Modal")
);
type Props = {
  forgottenEmailActive: boolean;
  I18n: any;
  closeModal: Function;
};

const AuthScreenForgottenEmailModal = (props: Props): JSX.Element => {
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [submittingForgottenEmail, setSubmittingForgottenEmail] =
    useState(false);
  const [forgottenEmailError, setForgottenEmailError] = useState("");
  const [forgottenEmailSuccess, setForgottenEmailSuccess] = useState("");
  const [country, setCountry] = useState("");
  const [countryId, setCountryId] = useState(0);
  const [countries, setCountries] = useState([]);
  const [dateOfBirth, setDateOfBirth] = useState("");

  const [token, setToken] = useState("");
  const [verified, setIsVerified] = useState(false);

  useEffect(() => {
    getCountriesList();
  }, []);

  const handleVerify = response => {
    setToken(response);
  };

  const handleExpire = () => {
    setIsVerified(false);
  };

  const submitForgottenEmail = (e: any) => {
    e.preventDefault();
    setSubmittingForgottenEmail(true);

    authAPI
      .submitForgottenEmail(
        userName,
        firstName,
        lastName,
        dateOfBirth,
        country,
        token
      )
      .then((resp: any) => {
        setSubmittingForgottenEmail(false);
        setForgottenEmailSuccess(resp);
        setForgottenEmailError("");
        return resp;
      })
      .catch((error: any) => {
        console.log("error", error);
        setForgottenEmailSuccess("");
        setForgottenEmailError(
          error.response.data.message !== undefined
            ? error.response.data.message
            : error.message
        );
        setSubmittingForgottenEmail(false);
        return error;
      });
  };

  const updateEmail = (id: string, value: string) => {
    setUserName(value);
  };

  const getCountriesList = () => {
    countriesApi.fetchCountries().then(resp => {
      setCountries(resp.countries);
    });
  };

  const handleCountryChange = (e: any) => {
    e.preventDefault();
    setCountryId(e.target.value);
    setCountry(e.target.options[e.target.selectedIndex].text);
  };

  const handleChange = (id: string, value: string) => {
    switch (id) {
      case "userName":
        setUserName(value);
        break;
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      default:
        break;
    }
  };

  const handleDateChange = (e: any) => {
    setDateOfBirth(e.target.value);
  };

  return (
    <Modal
      modalOpen={props.forgottenEmailActive}
      closeModal={props.closeModal}
      contentLabel="Forgotten Email"
      cancelButton
      className="auth-screen__username-modal"
    >
      <form>
        <h1>
          <FormattedMessage tagName="span" id="login-forgotten-email" />
        </h1>
        <span className="username-modal-message">
          <FormattedMessage
            tagName="span"
            id="login-forgotten-email-modal-message"
          />
        </span>
        <TextInput
          type="username"
          id="userName"
          className="auth-screen__form__input"
          removeDefaultStyle={true}
          label={props.I18n.username}
          onChange={handleChange}
        />
        <TextInput
          type="text"
          id="firstName"
          className="auth-screen__form__input"
          removeDefaultStyle={true}
          label={props.I18n.firstname}
          onChange={handleChange}
        />
        <TextInput
          type="text"
          id="lastName"
          className="auth-screen__form__input"
          removeDefaultStyle={true}
          label={props.I18n.lastname}
          onChange={handleChange}
        />
        <div className="text-input">
          <label className="text-input__label">
            <FormattedMessage tagName="span" id="settings-birth" />
          </label>
          <input
            type="date"
            className="auth-screen__form__input"
            value={dateOfBirth}
            pattern="\d{4}-\d{2}-\d{2}"
            onChange={handleDateChange}
          />
        </div>
        <div className={"text-input text-input__select"}>
          <FormattedMessage tagName="label" id="settings-country" />
        </div>
        <select
          className="auth-screen__form__dropdown"
          value={countryId}
          onChange={handleCountryChange}
          id="country"
        >
          {!countryId && (
            <option value={0}>
              <FormattedMessage id="home-register-select-country" />
            </option>
          )}
          {countries &&
            countries.map((country: any, index: number) => (
              <option key={index} value={country.id}>
                {country.name}
              </option>
            ))}
        </select>

        <span className="error-msg">{forgottenEmailError}</span>
        <span className="success-msg">{forgottenEmailSuccess}</span>
        <div className="auth-screen__form__recaptcha">
          <Recaptcha onVerify={handleVerify} onExpire={handleExpire} />
        </div>
        <div className="auth-screen__form__submit auth-screen__form__submit-no-set-height">
          <button
            id="submit_forgotten_email_button"
            type="submit"
            disabled={false}
            onClick={(e: any) => submitForgottenEmail(e)}
            className={"resend-button"}
          >
            <FormattedMessage tagName="span" id="button-submit" />
            {submittingForgottenEmail ? (
              <Suspense fallback={<div className="fallback">loading...</div>}>
                <LoadingSpinner />
              </Suspense>
            ) : (
              ""
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AuthScreenForgottenEmailModal;
